var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1h18v18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#093D54",
    d: "M15.506.217H2.494L.02 7.929l.347 7.854h17.268l.347-7.854z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACE0F9",
    d: "M17.981 7.929l-.346 7.855H.365L.019 7.929h2.366a1.318 1.318 0 00-.031.198 1.692 1.692 0 00-.007.102v.103l.03.905c.008.236.066.468.171.68.104.209.246.396.42.552a2.014 2.014 0 001.338.508h9.388a2.013 2.013 0 001.338-.508c.174-.156.317-.343.42-.553a1.65 1.65 0 00.171-.679l.03-.905V8.23a1.647 1.647 0 00-.038-.3h2.366z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E5B7C",
    d: "M15.475.217l-.251 5.675H2.746L2.496.217z"
  }))));
}
export default SvgInbox;